import React from 'react';
import { Modal } from "react-bootstrap";
import styles from "./modal.module.css";
import { Gallery } from "@/types/galleryData";
import { uploadGalleryHdriFile } from '../../pages/admin/files/service';

interface ModalProps {
    show: boolean;
    onHide: () => void;
    onSubmitted: (status: boolean) => void;
    batchUpdate: boolean;
    types: string;
    gallery: Gallery;
    file: File;
}

export const GalleryFileConfirmModal = ({file, show, onHide, onSubmitted, batchUpdate, types, gallery}: ModalProps) => {
    
    const [ updating, setUpdating ] = React.useState<boolean>(false);

    const updateHdri = async () => {
        try {
            setUpdating(true); 
            const respData = await uploadGalleryHdriFile(file, batchUpdate, types, gallery ? gallery._id : "");
            
            if (respData.status) {
                onSubmitted(true);
            } else {
                onSubmitted(false);
            }
            onHide();
        } catch (error) {
            onSubmitted(false);
        } finally {
            setUpdating(false);
        }
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton className={styles.background}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Are you sure to update gallery hdri file?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.background}>
                <div className="p-3">
                    <div>Batch Update: &nbsp; {batchUpdate ? "Yes" : "No"}</div>
                    <div>
                        {batchUpdate ? <>
                            Gallery Types: &nbsp; {types}
                        </> : <>
                            <div>Gallery Name: &nbsp; {gallery ? gallery.name : ""}</div>
                            <div>Gallery ID: &nbsp; {gallery ? gallery._id : ""}</div>
                        </>}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.background}>
                <button className="btn btn-success" onClick={onHide}>
                    Close
                </button>
                <button
                    className="btn btn-success" 
                    onClick={updateHdri} 
                    disabled={updating}
                >
                    {updating ? "Submitting..." : "Submit"}
                </button>
            </Modal.Footer>
        </Modal>
    )
}